// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__RR9L8","content":"styles_content__6trEA","title":"styles_title__knKxJ","closeButton":"styles_closeButton__uevVN"};